import React, { useEffect, useState } from "react";
import Moment from "react-moment";

import Modal from "react-modal";
import { Link, useParams } from "react-router-dom";
import {
  useGetOneVideoQuery,
  useGetVideosQuery,
} from "../../features/Videos/VideosApi";
import Navbar from "./Navbar";
import {
  useAddAssignmnetMarkMutation,
  useGetAssignmentMarkQuery,
  useGetAssignmentsQuery,
} from "../../features/Assignment/AssignmentApi";
import { useGetQuizzesQuery } from "../../features/QuizzesApi";
import { useSelector } from "react-redux";

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement("#root");

const CoursePlayer = () => {
  const [addAssignmnetMark] = useAddAssignmnetMarkMutation();

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setFormData({ ...formData, [name]: value });
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  //Modal

  const [modalIsOpen, setIsOpen] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  // function afterOpenModal() {
  //   // references are now sync'd and can be accessed.
  //   subtitle.style.color = "#f00";
  // }

  function closeModal() {
    setIsOpen(false);
  }

  const { data: assignments, isLoading: assignmentLoading } =
    useGetAssignmentsQuery() || {};
  const { data: assignmentMark } = useGetAssignmentMarkQuery() || {};

  const { data: quizzes } = useGetQuizzesQuery() || {};

  const { id } = useParams();
  const { data: videos, isLoading: videosLoading } = useGetVideosQuery() || {};
  const { data: video } = useGetOneVideoQuery(id) || {};

  useEffect(() => {
    document.title = "Course Player";
  });
  const existAssignment = assignments?.find(
    (elm) => parseInt(elm.video_id) === parseInt(video?.id)
  );
  console.log(existAssignment);
  const existQuizz = quizzes?.filter(
    (elm) => parseInt(elm.video_id) === parseInt(video?.id)
  );

  const auth = useSelector((state) => state.auth);
  const personMark = assignmentMark?.filter(
    (elm) => parseInt(elm.student_id) === parseInt(auth?.user?.id)
  );
  const userAssignment = personMark?.find(
    (elm) => parseInt(elm.assignment_id) === parseInt(id)
  );
  const [formData, setFormData] = useState({
    student_id: auth?.user?.id,
    student_name: auth?.user?.name,
    assignment_id: id,
    title: existAssignment?.title,
    createdAt: new Date(),
    totalMark: existAssignment?.totalMark,
    mark: 0,
    repo_link: "",
    status: "pending",
  });
  const handleSubmit = (e) => {
    e.preventDefault();

    addAssignmnetMark(formData);

    closeModal();
  };
  return (
    <div>
      <Navbar />

      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div className="grid grid-cols-3 gap-2 lg:gap-8">
            <div className="col-span-full w-full space-y-8 lg:col-span-2">
              {video ? (
                <div>
                  <iframe
                    width="100%"
                    className="aspect-video"
                    src={video?.url}
                    title="Things I wish I knew as a Junior Web Developer - Sumit Saha - BASIS SoftExpo 2023"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>

                  <div>
                    <h1 className="text-lg font-semibold tracking-tight text-slate-100">
                      {video?.title}
                    </h1>
                    {video ? (
                      <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
                        Uploaded on{" "}
                        <Moment format="DD MMMM YYYY">{video?.deadline}</Moment>
                      </h2>
                    ) : (
                      <span></span>
                    )}

                    <div className="flex gap-4">
                      {existAssignment &&
                        (userAssignment ? (
                          <button
                            disabled
                            className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm "
                          >
                            এসাইনমেন্ট জমা হয়েছে
                          </button>
                        ) : (
                          <button
                            className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
                            onClick={openModal}
                          >
                            এসাইনমেন্ট
                          </button>
                        ))}

                      {existQuizz && (
                        <Link
                          to={`/quiz/${video?.id}`}
                          className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
                        >
                          কুইজে অংশগ্রহণ করুন
                        </Link>
                      )}
                      <Modal
                        isOpen={modalIsOpen}
                        // onAfterOpen={afterOpenModal}
                        onRequestClose={closeModal}
                        style={customStyles}
                        contentLabel="Example Modal"
                      >
                        <form
                          className="mt-8 space-y-6"
                          onSubmit={handleSubmit}
                        >
                          <input type="hidden" name="remember" value="true" />
                          <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                              <label for="email-address" className="sr-only">
                                Github Repo Link
                              </label>
                              <input
                                id="repo_link"
                                name="repo_link"
                                type="text"
                                autocomplete="repo_link"
                                required
                                className="login-input rounded-t-md"
                                placeholder="Repo_link"
                                value={formData.repo_link}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div>
                            <button
                              type="submit"
                              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <p className="mt-4 text-sm text-slate-400 leading-6">
                      {video?.description}
                    </p>
                  </div>
                </div>
              ) : (
                <span>
                  <h1 style={{ textAlign: "center", fontSize: "50px" }}>
                    No videos Found
                  </h1>
                </span>
              )}
            </div>
            <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
              {videosLoading ? (
                <span>Loading...</span>
              ) : videos?.length > 0 ? (
                videos.map((video) => (
                  <div className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2 py-3">
                    {/* <!-- Thumbnail --> */}
                    <svg
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"
                      />
                    </svg>
                    {/* <!-- Description --> */}
                    <div clas="flex flex-col w-full">
                      <Link to={`/courseplayer/${video.id}`}>
                        <p className="text-slate-50 text-sm font-medium">
                          {video.title}
                        </p>
                      </Link>
                      <div>
                        <span className="text-gray-400 text-xs mt-1">
                          {video.duration} Mins
                        </span>
                        <span className="text-gray-400 text-xs mt-1"> | </span>
                        <span className="text-gray-400 text-xs mt-1">
                          {video.views} views
                        </span>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <span>videosError</span>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CoursePlayer;
